var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title || _vm.subtitle)?_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('div',{staticClass:"menu-page mt-6 mb-2"},[_c('page-hero',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }